import { Modal } from 'antd';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../../Constants/Spinner';
import { updateNewsPostAction } from '../../../module/action/NewsPosts';
import TicIcon from '../../../Assets/Icons/TicIcon';
import CrossIcon from '../../../Assets/Icons/CrossIcon';
import useAutosizeTextArea from '../../../Constants/useAutosizeTextArea';

function EditPostModal({
  isEditModalOpen,
  setIsEditModalOpen,
  showEditModal,
  handleEditOk,
  handleEditCancel,
  editPost,
  setEditPost,
}) {
  const [value, setValue] = useState(editPost.title_name);
  const dispatch = useDispatch();
  const updateNewsPostLoader = useSelector(e => e.NewsPosts.updateNewsPostLoader);
  const textAreaRef = useRef(null);

  const updatePost = () => {
    dispatch(updateNewsPostAction(editPost, handleEditOk));
  };
  useAutosizeTextArea(textAreaRef.current, value);

  return (
    <Modal
      footer={false}
      title={false}
      open={isEditModalOpen}
      onOk={handleEditOk}
      onCancel={handleEditCancel}
      className="max-w-[730px] w-full"
      width={'100%'}>
      <div className="py-[12px] px-[8px]">
        <h5 className="text-xl leading-[12px] font-semibold">Edit Post</h5>
        <textarea
          value={editPost.title_name}
          placeholder="Write post here "
          dir="rtl"
          ref={textAreaRef}
          rows={1}
          className="w-full border-[#E9EEE8] border-[1px] py-[19.5px] rounded-[10px] mt-4 px-[24px] text-sm "
          onChange={ev => {
            let data = { ...editPost };
            setValue(ev.target.value);
            data.title_name = ev.target.value;
            setEditPost(data);
          }}
        />
        <div className="flex items-center justify-between flex-wrap">
          <button
            disabled={updateNewsPostLoader}
            onClick={updatePost}
            className={`relative flex items-center justify-center mt-6 rounded-xl py-4 ${
              updateNewsPostLoader ? 'bg-[#2a9134]' : 'bg-[#EEF2F0] '
            }  text-black hover:bg-[#2a9134]  hover:text-white border-[1px] leading-[8px] outline-none border-[#EEF2F0] px-9   font-semibold sm:w-[calc(50%-8px)] w-full`}>
            {updateNewsPostLoader ? <Spinner /> : null}
            <div
              className={
                updateNewsPostLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'
              }>
              <TicIcon className="mr-[12.12px]" stroke="currentColor" />
              Confirm
            </div>
          </button>
          <button
            onClick={handleEditCancel}
            className="flex items-center justify-center mt-6 rounded-xl py-4 bg-[#EEF2F0]  text-black hover:bg-[#2a9134]  hover:text-white border-[1px] leading-[8px] outline-none border-[#EEF2F0] px-9   font-semibold sm:w-[calc(50%-8px)] w-full">
            <CrossIcon className="mr-[11.89px]" stroke="currentColor" />
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default EditPostModal;
